import type { SelectHTMLAttributes } from "vue"
import { defineComponent, inferProps, propsWithDefaults, useOnInput, type ReactiveComponent } from "vue-utils"

interface Props {
	value: boolean | null
	setValue(value: boolean | null): void

	nullText?: string
}

const BooleanSelect: ReactiveComponent<Props, SelectHTMLAttributes> = (initialProps, { attrs }) => {
	const props = propsWithDefaults(initialProps, {
		nullText: "Either",
	})

	function handleInput(value: string) {
		switch (value.toLowerCase()) {
			case "": {
				props.setValue(null)
				return
			}
			case "true": {
				props.setValue(true)
				return
			}
			case "false": {
				props.setValue(false)
				return
			}
		}
		throw new Error(`Invalid select boolean value '${value}'`)
	}

	return () => (
		<select value={props.value} onInput={useOnInput(handleInput)} {...attrs}>
			<option value="">{props.nullText}</option>
			<option value="true">Yes</option>
			<option value="false">No</option>
		</select>
	)
}

export default defineComponent(BooleanSelect, inferProps<Props>())
